<template>
  <bk-page class="updateEmailPage" :loading="loading" pageType="navPage" :navBarInfo="navBarInfo" @close="close">
		<bk-view class="view-title">
			<bk-lang code="userInfo_updateEmail_newAddress"></bk-lang>
		</bk-view>
		<bk-view class="view-form-main">
			<bk-view class="view-form-item">
				<bk-lang class="view-label" code="userInfo_updateEmail_curEmail"></bk-lang>
				<bk-view class="view-value">{{formData.beforeEmail}}</bk-view>
			</bk-view>
			<bk-view class="view-form-item">
				<bk-input showFocusStatus v-model:value="formData.email" />
			</bk-view>
			<bk-view class="view-form-item">
				<bk-button size="full" langCode="res_next_btn" @click="handleSave"></bk-button>
			</bk-view>
		</bk-view>


		<transition name="rightFadeIn">
      <bkEmailVerify 
				v-if="showPage==='bkEmailVerify'"  
				:email="formData.email" 
				@close="setShowPage()" 
				@confirm="handleEmailVerifyConfirm"
			/>
    </transition>

		<transition name="rightFadeIn">
      <changeSuccessfully 
				v-if="showPage==='changeSuccessfully'"  
				:email="formData.email" 
				@close="close" 
				@confirm="close"
			/>
    </transition>

	</bk-page>
</template>

<script>
	import { authReq } from '@/reqService';
	import bkEmailVerify from '@/components/bk-business/bk-emailVerify/bk-emailVerify.vue'
	import changeSuccessfully from './changeSuccessfully/changeSuccessfully.vue'

	export default {
		name: 'updateEmail',
		components:{ bkEmailVerify, changeSuccessfully}, 
		props:{
			curRows:Object,
		},
		data (){
			return {
				loadView:'',
				navBarInfo: {
					langCode_title:'userInfo_updateEmail_title',
					backFlag: true,
				},
				formData:{},
				userInfo:this.$bk_getUserInfo(),
				showPage:'',
			};
		},
		computed:{
			formConfig (){
				return {
					required:true,
					items:[
						{e:'input', langCode:'userInfo_updateEmail_curEmail', key:'beforeEmail', disabled: true },
						{e:'input', langCode:'userInfo_personal_emailAddress', key:'email' },
					]
				};
			}
		},
		mounted(){
			this.initData()
		},
		methods:{
			initData(){
				if(this.curRows){
					const { email} = this.curRows
					this.formData = {beforeEmail: email }
				}
			},
			close(){
				this.$emit('close')
			},
			setShowPage (showPage=''){
				this.showPage = showPage;
			},
			async handleSave (){
				const { beforeEmail, email } = this.formData;

				if(!email){
					this.$bk_message.error({langCode:'userInfo_updateEmail_msg_enterEmail'})
					return false;
				}

				if( beforeEmail === email ){
					this.$bk_message.error({langCode:'userInfo_updateEmail_msg_sameEmail'})
					return false
				}
				
				await authReq.requestGetCheckEmailRegister(this, { email});

				this.setShowPage('bkEmailVerify')
			},
			// 提交
			handleEmailVerifyConfirm(verifyCode){
				const params = {
					email: this.formData.email,
					verifyCode
				}

				this.loadView='save';

				authReq.requestPostUpdateUserEmail(this, params).then(() => {
					this.loadView=''
					this.$emit('reload')
					this.setShowPage('changeSuccessfully');
				}).catch(()=>{
					this.loadView=''
				})
			}
		}
		
	};
</script>

<style lang="less">
@import './updateEmail.less';
</style>